// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"43":"page-policy","181":"page-policy-detail","193":"page-policy-personal-data","374":"page-partners"}[chunkId] + "." + {"43":"9f308afe","181":"9aa81bd8","193":"25f07181","374":"1058959f"}[chunkId] + ".chunk.js";
};